import { combineReducers } from "@reduxjs/toolkit";
import homeReducer from "features/home/homeSlice";
import drawerReducer from "features/drawer/drawerSlice";
import appBackdropReducer from "features/appBackdrop/appBackdropSlice";
import productsReelReducer from "features/ProductReel/productReelSlice";
import filtersReducer from "features/Filters/filtersSlice";
import breadcrumbReducer from "features/breadcrumb/breadcrumbSlice";
import headerReducer from "features/header/headerSlice";
import videoPlayerReducer from "features/VideoPlayer/videoPlayerSlice";
import categoryReducer from "features/category/categorySlice";
import cartReducer from "features/cart/cartSlice";
import rootModalReducer from "features/rootModal/rootModalSlice";
import paymentReducer from "features/payment/paymentSlice";
import productDetailsReducer from "features/productDetails/productDetailsSlice";
import adminReducer from "features/admin/adminSlice";
import authReducer from "features/authentication/authSlice";
import productsAdminReducer from "features/admin/Products/productsAdminSlice";
import tagsAdminReducer from "features/admin/Tags/tagsAdminSlice";
import emailSenderAdminReducer from "features/admin/EmailSender/emailSenderSlice";
import bannersAdminReducer from "features/admin/Banners/bannersAdminSlice";
import accessoriesReducer from "features/accessories/accessoriesSlice";
import compareReducer from "features/compare/compareSlice";
import messageReducer from "features/message/messageSlice";
import storeReviewsReducer from "features/storeReviews/storeReviewsSlice";
import commentsAdminReducer from "features/admin/Comments/commentsAdminSlice";
import metasAdminReducer from "features/admin/Meta/metasAdminSlice";
import ordersAdminReducer from "features/admin/Orders/ordersAdminSlice";
import videosAdminReducer from "features/admin/Videos/videosAdminSlice";
import galleryReducer from "features/gallery/gallerySlice";
import adminGalleryReducer from "features/admin/Gallery/adminGallerySlice";
import promoReducer from "features/admin/Promotion/promoAdminSlice";
import accessoryDetailsReducer from "features/accessoryDetailts/accessoryDetailsSlice";
import installationAdminReducer from "features/admin/Installations/installationAdminSlice";
import paginationReducer from "features/pagination/paginationSlice";
import filtersAdminReducer from "features/admin/Filters/filtersAdminSlice";
import categoriesReducer from "features/categories/categoriesSlice";
import accessoriesAdminReducer from "features/admin/Accessories/accessoriesAdminSlice";
import searchReducer from "features/searchBar/searchSlice";
import footerReducer from 'components/Footer/footerSlice';

const rootReducer = combineReducers({
  appBackdrop: appBackdropReducer,
  breadcrumb: breadcrumbReducer,
  category: categoryReducer,
  cart: cartReducer,
  drawer: drawerReducer,
  filters: filtersReducer,
  header: headerReducer,
  home: homeReducer,
  payment: paymentReducer,
  productsReel: productsReelReducer,
  productDetails: productDetailsReducer,
  rootModal: rootModalReducer,
  videoPlayer: videoPlayerReducer,
  admin: adminReducer,
  auth: authReducer,
  productsAdmin: productsAdminReducer,
  tagsAdmin: tagsAdminReducer,
  emailSenderAdmin: emailSenderAdminReducer,
  compare: compareReducer,
  message: messageReducer,
  bannersAdmin: bannersAdminReducer,
  storeReviews: storeReviewsReducer,
  commentsAdmin: commentsAdminReducer,
  metasAdmin: metasAdminReducer,
  accessories: accessoriesReducer,
  ordersAdmin: ordersAdminReducer,
  videosAdmin: videosAdminReducer,
  gallery: galleryReducer,
  adminGallery: adminGalleryReducer,
  promoAdmin: promoReducer,
  accessoryDetails: accessoryDetailsReducer,
  installationAdmin: installationAdminReducer,
  pagination: paginationReducer,
  filterAdmin: filtersAdminReducer,
  categories: categoriesReducer,
  accessoriesAdmin: accessoriesAdminReducer,
  search: searchReducer,
  footer: footerReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
